import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import NextImage from '@/components/media/StorefrontImage';
import { toStorefrontMediaUrl } from '@/lib/media-url';
import type { ImageBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Image.module.css';
interface ImageProps {
  block: ImageBlock;
  blockId: string;
}
export function Image(t0) {
  const $ = _c(30);
  const {
    block,
    blockId
  } = t0;
  const {
    image,
    caption,
    href,
    target,
    rel,
    priority
  } = block;
  const isLazyPlaceholderSrc = image.src.startsWith("data:image/");
  const renderedSrc = isLazyPlaceholderSrc && image.sourceSrc ? image.sourceSrc : image.src;
  const auditSrc = image.sourceSrc ?? renderedSrc;
  const isPlaceholderPixel = image.width === 1 && image.height === 1;
  const usingNextImage = !!(image.width && image.height) && !isPlaceholderPixel || image.fill;
  const shouldLoadEagerly = priority || !image.width && !image.height && !image.fill;
  const t1 = isPlaceholderPixel ? styles.placeholderPixel : null;
  let t2;
  if ($[0] !== t1) {
    t2 = [styles.image, t1].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageClassName = t2.join(" ");
  let t3;
  if ($[2] !== auditSrc || $[3] !== image.alt || $[4] !== image.fill || $[5] !== image.height || $[6] !== image.sizes || $[7] !== image.width || $[8] !== imageClassName || $[9] !== priority || $[10] !== renderedSrc || $[11] !== shouldLoadEagerly || $[12] !== usingNextImage) {
    t3 = usingNextImage ? <NextImage src={renderedSrc} alt={image.alt} width={image.fill ? undefined : image.width} height={image.fill ? undefined : image.height} fill={image.fill} sizes={image.sizes} priority={priority} className={imageClassName} data-src={auditSrc} /> : <img src={toStorefrontMediaUrl(renderedSrc)} alt={image.alt} width={image.width} height={image.height} className={imageClassName} loading={shouldLoadEagerly ? "eager" : "lazy"} data-src={auditSrc} />;
    $[2] = auditSrc;
    $[3] = image.alt;
    $[4] = image.fill;
    $[5] = image.height;
    $[6] = image.sizes;
    $[7] = image.width;
    $[8] = imageClassName;
    $[9] = priority;
    $[10] = renderedSrc;
    $[11] = shouldLoadEagerly;
    $[12] = usingNextImage;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const inner = t3;
  const t4 = image.fill ? styles.fillWrapper : styles.staticWrapper;
  let t5;
  if ($[14] !== inner || $[15] !== t4) {
    t5 = <div className={t4}>{inner}</div>;
    $[14] = inner;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== caption) {
    t6 = caption && caption.length > 0 ? <figcaption className={styles.caption}><RichSegments segments={caption} /></figcaption> : null;
    $[17] = caption;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== blockId || $[20] !== t5 || $[21] !== t6) {
    t7 = <figure className={styles.figure} data-cms-block-id={blockId} data-cms-field="image">{t5}{t6}</figure>;
    $[19] = blockId;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const figure = t7;
  if (href) {
    let t8;
    if ($[23] !== href) {
      t8 = toStorefrontMediaUrl(href);
      $[23] = href;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== figure || $[26] !== rel || $[27] !== t8 || $[28] !== target) {
      t9 = <a href={t8} target={target} rel={rel} className={styles.link}>{figure}</a>;
      $[25] = figure;
      $[26] = rel;
      $[27] = t8;
      $[28] = target;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    return t9;
  }
  return figure;
}